export default "__VITE_ASSET__8dm3C3jsXN$7yE9lr2nMCQ__"